import { render } from "./BookList.vue?vue&type=template&id=22332c1a"
import script from "./BookList.vue?vue&type=script&lang=js"
export * from "./BookList.vue?vue&type=script&lang=js"

import "./BookList.vue?vue&type=style&index=0&id=22332c1a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__